export var keyMap = {
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  RETURN: 13,
  ENTER: 14,
  ESCAPE: 27,
  BACKSPACE: 8
};